module.exports = __webpack_public_path__ + "img/image_10.04c24e6b.png";